import React from 'react';

const BackgroundVideo = (videoData) => {
    return (
        <div className="background-video-container">
            {/* Video de fondo */}
            <video
                className="background-video"
                autoPlay
                loop
                muted
                playsInline // Para asegurar que funciona en móviles
            >
                <source src={videoData.videoData} type="video/mp4" />                
            </video>
        </div>
    );
};

export default BackgroundVideo;
